<div class="progress-container">
  <!-- Title -->
  <div class="title" *ngIf="suffixSetting">{{ totalValue }} {{ suffixSetting | translate }}</div>

  <!-- Progress Bar -->
  <div #barContainer class="bar-container" (mouseleave)="onLeave()" >
    <ng-container *ngIf="!isEmptyData; else emptyBar">
      <ng-container *ngFor="let item of data; let i = index">
        <div
        *ngIf="calcBarWidth(item) > 0"
        class="bar-wrapper"
        (mousemove)="onHover(i, $event)"
        [style.flex]="'1 1 ' + calcBarWidth(item) + '%'"
      >
        <div
          class="bar"
          [ngClass]="{ hovered: hoveredIndex === i }"
          style="width: 100%"
          [style.background]="item.color"
        ></div>
      </div>

      </ng-container>
    </ng-container>

    <ng-template #emptyBar>
      <div
        class="noData-bar-wrapper"
        (mousemove)="onHover(0, $event)"
        [style.flex]="'1 1 100%'"
      >
        <div
          class="bar"
          [ngClass]="{ hovered: hoveredIndex === 0 }"
          style="width: 100%"
          [style.background]="NoDataColor"
        ></div>
      </div>
    </ng-template>
  </div>

  <!-- Tooltip -->
  <xux-tooltip
    *ngIf="hoveredIndex !== -1"
    [label]="
      !isEmptyData ? (data[hoveredIndex].label | translate) + (suffixSetting | translate) : (NoDataText | translate)
    "
    [count]="!isEmptyData ? data[hoveredIndex].value : null"
    [top]="tooltipY"
    [left]="tooltipX"
    [color]="!isEmptyData ? data[hoveredIndex].color : NoDataColor"
  ></xux-tooltip>

  <!-- Legend -->
  <div style="width: 100%">
    <div class="xux-legend">
      <div class="legend-item" *ngFor="let item of data; let i = index">
        <div class="legend-icon" [style.background]="item.color"></div>
        <div class="legend-label">{{ item.label | translate }}</div>
      </div>
    </div>
  </div>
</div>
